<template>
  <div class="getty-links">
    <div class="getty-links-container">
      <div
        class="getty-links-container-item"
        v-for="(item, index) in nav"
        :key="index"
      >
        <a v-if="!item.links" :href="item.url">
          <b-button :active="item.active">
            {{ item.label }}
          </b-button>
        </a>
        <Dropdown
          v-else
          :info="item.links"
          :title="item.label"
          :active="item.active"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Dropdown from "@/components/Dropdown";

export default {
  name: "HeaderNav",
  data() {
    return {
      menu: ""
    };
  },
  components: {
    Dropdown
  },
  props: {
    info: Object,
    nav: Array,
    route: String
  }
};
</script>
